// Iniciales del avatar de empleado: primeras dos palabras del nombre completo.
// Regla compartida por Desktop (Expediente) y Mobile (listado y credencial).
// Extraída sin cambios desde src/components/Empleados.jsx (M.2A).
export function inicialesEmpleado(nombreCompleto) {
  return nombreCompleto.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
}
